<template>
  <BaseFetchData :action="fetchData">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <ul
        v-if="fetchDataProps.status.resolved && smsMessageTrackingLogs.length"
        class="bg-white shadow rounded ring-1 ring-black ring-opacity-5 divide-y overflow-hidden"
      >
        <li v-for="smsMessageTrackingLog in smsMessageTrackingLogs" :key="smsMessageTrackingLog.id">
          <MessageListLine :sms-message-tracking-log="smsMessageTrackingLog" />
        </li>
      </ul>
    </template>
  </BaseFetchData>
</template>

<script>
import { contactSmsMessageTrackingLogsClient } from '@/api/clients';
import MessageListLine from './MessageListLine.vue';

export default {
  components: {
    MessageListLine,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      smsMessageTrackingLogs: [],
    };
  },
  methods: {
    fetchData() {
      return contactSmsMessageTrackingLogsClient
        .list(this.contact.id, {
          include: ['smsMessage', 'sender'],
        })
        .then((response) => {
          this.smsMessageTrackingLogs = response.data;
        });
    },
  },
};
</script>
